import { render, staticRenderFns } from "./deviceTransfer.vue?vue&type=template&id=1a549762&scoped=true"
import script from "./deviceTransfer.vue?vue&type=script&lang=ts"
export * from "./deviceTransfer.vue?vue&type=script&lang=ts"
import style0 from "./deviceTransfer.vue?vue&type=style&index=0&id=1a549762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a549762",
  null
  
)

export default component.exports